import React from 'react';

import { Box } from '@material-ui/core';

import { object } from 'prop-types';

import { Text } from './styles';

const NoPrice = ({ boxProps }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="5px"
    border="1px solid #c0c0c0"
    textAlign="center"
    padding="5px"
    minHeight="70px"
    {...boxProps}
  >
    <Text>
      Valores: <a href="/cliente/login">entre</a> ou <a href="/cliente/cadastro">cadastre-se</a>
    </Text>
  </Box>
);

NoPrice.propTypes = {
  boxProps: object,
};

export default NoPrice;
